'use strict';

module.exports = (app) => app.controller('basketToDemandController', /* @ngInject */ function ($scope, demandService) {

	$scope.copyFromBasket = copyFromBasket;

	/**
	 * @param basketId {number}
	 * @returns {Promise<void>}
	 */
	async function copyFromBasket(basketId) {
		await demandService.copyFromBasket(basketId);
		window.navigateToPurchaseRequisition('client/rfq/demand/create');
	}
});

